import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { RegistrationService } from '../../services/registration/registration.service';
import { RegistrationModel } from '../../models/registrationmodel';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';

@Component({
  selector: 'app-register',
  templateUrl: './register.html',
  styleUrls: ['./register.css'],
  imports: [ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule],
  providers: [provideNgxMask()], // Provide at the component level
})
export class RegisterComponent implements OnInit{
  @ViewChild('listofFiles') tableRef: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;

  piList: any = [];
  showDivACH: boolean = false;
  submitted = false;
  clicked = false;
  clickedOnce = false;
  addButtonClicked = false;
  showDivOtherHealthType: boolean = false;
  allCompanyHealthTypes: any = [];
  allInsuranceQuestion: any = [];
  allStates: any = [];
  supportingDocuments: File[] = [];
  claimantsInformation: FormGroup;
  submittedClaim: RegistrationModel;
  response: string | undefined;
  changed = false;
  dateLoaded: Date;
  claimStartTime: string;
  claimEndTime: string;
  showDivSubmittalErrorMessage: boolean = false;
  showDivSectionB: boolean = false;

  validation_TransactionalClaimsDataAvailableErrorMessage = {
    listNumber: [
      { type: 'required', message: 'This Field is required' },
      { type: "minlength", message: "Field must be at least 2 characters" },
      { type: "maxlength", message: "Field cannot be more than 50 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    totalAmountPaid: [
      { type: 'required', message: 'This Field is required' },
      { type: "maxlength", message: "Field cannot be more than 15 digits" },
      { type: "pattern", message: "Only use numbers with optional period (.) and up to 4 digits past decimal" }
    ],
    genericDrugName: [
      { type: 'required', message: 'This Field is required' },
    ],
  };

  constructor(
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private storage: LocalStorageService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private registrationService: RegistrationService) { }

  ngOnInit() {
    this.dateLoaded = new Date();
    this.claimStartTime = this.dateLoaded.toLocaleTimeString();
    this.loadAllStates();
    this.claimantsInformation = this.fb.group({
      name1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      name2: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      street1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      street2: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      city: ['', Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      state: ['', Validators.compose([Validators.required])],
      claimantType: ['Third-party Payor'],
      zip: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      phone1: ['', Validators.compose([Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],
      email: ['', Validators.compose([Validators.maxLength(255), Validators.pattern("^[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],
      googleRecaptchaToken: ['', Validators.compose([Validators.required])]
    });
  }

  loadAllStates() {
    this.httpClient.get("/assets/States.json").subscribe(data => {
      /* console.log(data);*/
      this.allStates = data;
    })
  }
  get f() { return this.claimantsInformation.controls; }

  resolved(captchaResponse: string) {
    this.response = captchaResponse;
  }



  onSubmit() {
    this.submitted = true;
    this.dateLoaded = new Date();
    this.claimEndTime = this.dateLoaded.toLocaleTimeString();

    // stop here if form is invalid
    if (this.claimantsInformation.invalid) {
      return;
    }

    this.clicked = true;
    const claimant = this.claimantsInformation.value;
    claimant.wasClaimantNoticed = true;
    claimant.claimStartTime = this.claimStartTime;
    claimant.claimEndTime = this.claimEndTime;


 


    this.spinner.show();

    /*console.log(claimant);*/
    // this.CreateClaimant(claimant);


    // Single API call
    this.registrationService.createRegistration(claimant).subscribe({
      next: (res) => {
        this.storage.store('claimant', res);
        this.claimantsInformation.reset();
        this.spinner.hide();
        this.router.navigate(['/register-complete']);
      },
      error: err => {
        this.spinner.hide();
        console.group('Claimant submission failed');
        console.log('Status:', err.status);
        console.log('Error:', err.error);
        console.groupEnd();
      }
    });
  }

  // CreateClaimant(claimant: Claimants) {
  //   this.claimantService.createClaimant(claimant).subscribe(res => {
  //     this.submittedClaim = res;
  //     this.storage.store('claimant', this.submittedClaim);
  //     this.submitted = false;
  //     this.claimantsInformation.reset();
  //     this.spinner.hide();
  //     this.router.navigate(['/complete']);
  //   });
  // }
}
